/**
 * Curated emoji set for appointment tags. Same 16 emojis, in the same order,
 * as the booking-calendar design prototype (`calendar-data.js` TAG_EMOJIS).
 * No emoji-picker package: the supply-chain install freeze rules one out, and
 * a small fixed grid is what the design shows. `label` is the accessible name.
 */
import type { EmojiOption } from "../common/EmojiPicker";

/** Kept as an alias of the shared EmojiOption for existing imports. */
export type TagEmojiOption = EmojiOption;

export const TAG_EMOJIS: TagEmojiOption[] = [
  { emoji: "⭐", label: "Star" },
  { emoji: "\u{1F451}", label: "Crown" },
  { emoji: "\u{1F48E}", label: "Gem" },
  { emoji: "\u{1F381}", label: "Gift" },
  { emoji: "\u{1F4E3}", label: "Megaphone" },
  { emoji: "\u{1F4F8}", label: "Camera" },
  { emoji: "\u{1F4AC}", label: "Speech bubble" },
  { emoji: "\u{1F33F}", label: "Herb" },
  { emoji: "⚠️", label: "Warning" },
  { emoji: "\u{1F4B3}", label: "Credit card" },
  { emoji: "\u{1F382}", label: "Birthday cake" },
  { emoji: "\u{1F697}", label: "Car" },
  { emoji: "❤️", label: "Heart" },
  { emoji: "\u{1F525}", label: "Fire" },
  { emoji: "\u{1F338}", label: "Blossom" },
  { emoji: "\u{1F4CC}", label: "Pin" },
];
